import { render } from "./VueExMXN.vue?vue&type=template&id=583b26a4"
import script from "./VueExMXN.vue?vue&type=script&lang=js"
export * from "./VueExMXN.vue?vue&type=script&lang=js"

import "./VueExMXN.vue?vue&type=style&index=0&id=583b26a4&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__